import { ObservableArray, View } from "binder"
import { TypeSelectorViewModel } from "../typeSelector/typeSelector-viewModel";
import { IDefaultValueManipulator } from "./defaultValueManipulation/defaultValueManipulator";
import { PropertyManipulationViewModel } from "./propertyManipulation-viewModel";

export class PropertyManipulationView extends View<PropertyManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-8816F487-0691-4684-93A9-AED3C72BEC32"
    }
    loadHtml(): string {
        let element = require('./propertyManipulation.html').default;
        let style = require('./propertyManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set typeSelector(v: TypeSelectorViewModel) { this._typeSelector = v; } public get typeSelector(): TypeSelectorViewModel { return this._typeSelector;} private _typeSelector: TypeSelectorViewModel;
    public set shallInitialize(v: boolean) { this._shallInitialize = v; } public get shallInitialize(): boolean { return this._shallInitialize;} private _shallInitialize: boolean;
    public set defaultValueSelector(v: IDefaultValueManipulator) { this._defaultValueSelector = v; } public get defaultValueSelector(): IDefaultValueManipulator { return this._defaultValueSelector;} private _defaultValueSelector: IDefaultValueManipulator;

    confirm(){
        this.dataContext.confirm();
    }
    back(){
        this.dataContext.back();
    }

}
